import { Icon } from '@doordash/design-language';
import * as React from 'react';
import { MissingImageIcon } from './recommendationStyles';

const EmptyIcon: React.FC<{ fromCart?: boolean }> = ({ fromCart = false }) => (
  <MissingImageIcon fromCart={fromCart}>
    <Icon type={Icon.Types.FoodBowlFill} size={fromCart ? Icon.Sizes.Medium : Icon.Sizes.XLarge} color="#CBD5E1" />
  </MissingImageIcon>
);

export default EmptyIcon;
